import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FeatureContext } from "./FeatureContext";
import type Feature from "ol/Feature";

interface FeatureProviderProps {
  children: React.ReactNode;
}

const FeatureProvider = ({ children }: FeatureProviderProps) => {
  const location = useLocation();
  const [selectedFeatures, setSelectedFeatures] = useState<Feature[]>([]);

  useEffect(() => {
    // Clear selected features when the route changes
    setSelectedFeatures([]);
  }, [location.pathname]);

  const addFeature = (feature: Feature) => {
    setSelectedFeatures((prev) => [...prev, feature]);
  };

  const removeFeature = (feature: Feature) => {
    setSelectedFeatures((prev) => prev.filter((f) => f !== feature));
  };

  const clearFeatures = () => {
    setSelectedFeatures([]);
  };

  return (
    <FeatureContext.Provider
      value={{
        selectedFeatures,
        setSelectedFeatures,
        addFeature,
        removeFeature,
        clearFeatures,
      }}
    >
      {children}
    </FeatureContext.Provider>
  );
};

export default FeatureProvider;
